// extracted by css-extract-rspack-plugin
export default {"cls1":"ChurnedUserReactivationButton-cls1_PXn","cls2":"ChurnedUserReactivationButton-cls2_cC8 ChurnedUserReactivationButton-cls1_PXn"};